var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.501 0C30.6696 0 0.000976562 30.6686 0.000976562 68.5C0.000976562 106.331 30.6696 137 68.501 137C106.332 137 137.001 106.331 137.001 68.5C136.958 30.6865 106.314 0.0433024 68.501 0V0ZM92.9654 102.751H53.8229C51.1203 102.751 48.9298 100.56 48.9298 97.8576C48.9298 97.6261 48.9462 97.3947 48.979 97.1647L52.6612 71.3848L45.2237 73.2453C44.8354 73.3439 44.4368 73.3932 44.0366 73.3932C41.3339 73.3902 39.1464 71.1982 39.1479 68.4955C39.1509 66.2528 40.6769 64.2997 42.8525 63.7532L54.1544 60.928L58.7639 28.6632C59.1462 25.9874 61.6248 24.1299 64.3006 24.5122C66.9764 24.8944 68.834 27.3731 68.4517 30.0489L64.4052 58.3657L81.9934 53.9683C84.611 53.3008 87.2733 54.8821 87.9393 57.4997C88.6068 60.1172 87.0255 62.7796 84.4079 63.4471C84.393 63.45 84.378 63.4545 84.3631 63.4575L62.909 68.821L59.4612 92.9644H92.9654C95.668 92.9644 97.8585 95.1549 97.8585 97.8576C97.8585 100.559 95.668 102.751 92.9654 102.751Z",
    fill: "#374C98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtc);
export default __webpack_public_path__ + "static/media/ltc.04aeda5cfb2769bf7ee6b4ab8551aa03.svg";
export { ForwardRef as ReactComponent };